import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { fetchOpDefs } from 'modules/opDefs/data/sagas';
import { fetchProcesses } from 'modules/processes/data/sagas';

import service from 'services/customInterrogationService';

import { initMaterialStore } from 'store/materials/sagas';

import history from 'utils/browserHistory';

import {
  deleteInterrogation,
  receiveCustomInterrogation,
  update,
  types,
} from './actions';
import { getCustomInterrogation } from './reducer';

export default function* root() {
  yield takeLatest(
    types.UPDATE_INTERROGATION_REQUEST,
    watchUpdateInterrogationRequest,
  );
  yield takeLatest(
    types.DELETE_INTERROGATION_REQUEST,
    watchDeleteInterrogationRequest,
  );
}

export function* initCustomInterrogationDetailsPage({ match }) {
  const customInterrogationId = match.params.customInterrogationId;
  const customInterrogation = yield call(service.get, customInterrogationId);
  yield put(receiveCustomInterrogation({ customInterrogation }));
  yield all([call(initMaterialStore), call(fetchOpDefs), call(fetchProcesses)]);
}

function* watchUpdateInterrogationRequest(action) {
  const { id, data } = action.payload;
  try {
    if (Object.keys(data).includes('taskInputs')) {
      data.taskInputs = JSON.parse(data.taskInputs);
    }
    const newInterrogation = yield call(service.update, id, data);
    yield put(update.success({ customInterrogation: newInterrogation }));
  } catch (error) {
    yield put(update.error(error));
  }
}

function* watchDeleteInterrogationRequest() {
  try {
    const customInterrogation = yield select(getCustomInterrogation);
    const interrogationId = customInterrogation.id;
    yield call(service.delete, interrogationId);
    history.push('/processes/interrogations');
    yield put(deleteInterrogation.success());
  } catch (error) {
    yield put(deleteInterrogation.error(error));
  }
}
